<template>
    <v-data-table v-bind:headers="headers" :items="items" item-key="sta_id" :search="search"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:[`item.pro_label`]="{ item }">
            {{ item.pro_label }}
        </template>
        <template v-slot:[`item.pro_typ_id_projection`]="{ item }">
            <v-chip small outlined label>{{ typeListById[item.pro_typ_id_projection].typ_name }}</v-chip>
        </template>
        <template v-slot:[`item.pro_sta_id`]="{ item }">
            <v-chip small outlined label>{{ stateListById[item.pro_sta_id].sta_label }}</v-chip>
        </template>
        <template v-slot:[`item.pro_id`]="{ item }">
            <v-btn outlined small color="grey" class="ml-2 elevation-1" :to="'/projects/' + item.pro_id + '/view'">
                <v-icon left class="mr-2">mdi-pencil</v-icon>Modifier
            </v-btn>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
    </v-data-table>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useProjectStore } from '@/stores/project'

export default {
    name: 'projects-list',
    computed: {
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useProjectStore, {itemList: 'itemList', metaItems: 'metaItems' }),
        pages () {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        }
    },
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Nom',          align: 'left', value: 'pro_label'},
            { text: 'Projection',   align: 'left', value: 'pro_typ_id_projection'},
            { text: 'Statut',       align: 'left', value: 'pro_sta_id'},
            { text: 'Début',        value: 'pro_date_cal'},
            { text: 'Fin',          value: 'pro_date_cal_end' },
            { text: 'Modification', value: 'pro_id' }
            ],
            items: [],
            enableAdd: true,
            modalEvent : false,
        }
    },
    mounted: function (){
        this.getItems()
    },
    methods: {
        ...mapActions(useProjectStore, { fetchItems: 'fetchItems' }),
        getItems(){
            this.$http.get( '/projects?per_page=false' ).then( (response) => {
                this.items = response.data.data
            })
        },
        handlePage(index){
            this.pagination.limit = this.pagination.rowsPerPage * (index - 1)
        },
    },
}
</script>